interface RichTextProps {
	html: string;
	className?: string;
	as?: 'div' | 'span';
}

export const RichText = ({ html, className, as: Tag = 'div' }: RichTextProps) => (
	<Tag className={className} dangerouslySetInnerHTML={{ __html: html }} />
);

export const hasRichTextContent = (html: string): boolean =>
	html
		.replace(/<[^>]*>/g, '')
		.replace(/&nbsp;|&#160;|\s/g, '')
		.trim().length > 0;
